import styled from 'styled-components';

import IconComponent from '@/components/Base/Icon';
import {
  colorBlack900,
  colorPrimary400,
  colorWhite,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryLaptopMin,
  mediaQueryMobileLargeMin,
  mediaQueryMobileMin,
} from '@/styleUtils';

export const Wrapper = styled.div`
  width: 100%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.14);
  border-radius: 2px;
  background: ${colorWhite};
`;

export const Banner = styled.div`
  position: relative;

  ${(props) => {
    const { img } = props;
    const gradient =
      'linear-gradient(180deg, rgba(0, 0, 0, 3e-05) 0%, rgba(13, 24, 84, 0.048) 100%)';

    if (img) {
      return `
        background-image: url(https://minfin.com.ua${img});
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        padding-top: 32%;
      `;
    }

    return `
      min-height: 40px;
      background: ${gradient};
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      
      @media ${mediaQueryMobileLargeMin} {
        min-height: 90px;
      }
    `;
  }}
`;

export const MainInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${colorWhite};
  padding: 16px;
  position: relative;

  @media ${mediaQueryMobileMin} {
    padding: 16px 16px 0;
  }
`;

export const LogoWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const Logo = styled.div`
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colorWhite};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.102893);
  border-radius: 4px;
  margin: -44px 24px 0 0;

  @media ${mediaQueryMobileMin} {
    width: 124px;
    height: 124px;
    margin: -92px 24px 0 0;
  }
`;

export const Img = styled.img`
  max-width: 52px;
  max-height: 52px;

  @media ${mediaQueryMobileMin} {
    max-width: 112px;
    max-height: 112px;
  }
`;

export const Name = styled.h1`
  font-family: ${fontFamilySecondary};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: ${colorBlack900};

  @media ${mediaQueryMobileMin} {
    font-size: 20px;
    line-height: 26px;
  }
`;

const Button = styled.a`
  padding: 4px 12px;
  border: 1px solid ${colorPrimary400};
  box-sizing: border-box;
  font: normal normal 14px/24px ${fontFamilyPrimary};
  color: ${colorPrimary400};
  transition: 0.2s;

  &:hover,
  &:visited,
  &:active {
    color: ${colorPrimary400};
    opacity: 0.8;
  }
`;

export const LinkToReview = styled(Button)`
  width: max-content;
  font-weight: 700;
  display: none;
  flex-shrink: 0;
  align-items: center;

  @media ${mediaQueryLaptopMin} {
    display: flex;
  }
`;

export const Icon = styled(IconComponent)`
  width: 16px;
  height: 16px;
  margin: 0 8px 0 0;
`;

export const FiltersFormWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  gap: 20px;

  @media ${mediaQueryLaptopMin} {
    padding: 24px 16px;
    gap: 24px;
  }
`;

export const AdvertiserNoteWrapper = styled.div`
  display: flex;
  width: 100%;
`;
